// Keenthemes' plugins
window.KTUtil = require('./components/util.js');
window.KTApp = require('./components/app.js');
window.KTCard = require('./components/card.js');
window.KTCookie = require('./components/cookie.js');
window.KTDialog = require('./components/dialog.js');
window.KTHeader = require('./components/header.js');
window.KTMenu = require('./components/menu.js');
window.KTOffcanvas = require('./components/offcanvas.js');
window.KTScrolltop = require('./components/scrolltop.js');
window.KTToggle = require('./components/toggle.js');
window.KTWizard = require('./components/wizard.js');

// Metronic layout base js
window.KTLayout = require("./layout/initialize.js");
window.KTLayoutAside = require('./layout/base/aside.js');
window.KTLayoutAsideMenu = require('./layout/base/aside-menu.js');
window.KTLayoutContent = require('./layout/base/content.js');
window.KTLayoutFooter = require('./layout/base/footer.js');
window.KTLayoutHeader = require('./layout/base/header.js');
window.KTLayoutHeaderMenu = require('./layout/base/header-menu.js');
window.KTLayoutHeaderTopbar = require('./layout/base/header-topbar.js');
window.KTLayoutStickyCard = require('./layout/base/sticky-card.js');
window.KTLayoutStretchedCard = require('./layout/base/stretched-card.js');
window.KTLayoutSubheader = require('./layout/base/subheader.js');

// Metronic layout extended js
window.KTLayoutChat = require('./layout/extended/chat.js');
window.KTLayoutDemoPanel = require('./layout/extended/demo-panel.js');
window.KTLayoutExamples = require('./layout/extended/examples.js');
window.KTLayoutQuickActions = require('./layout/extended/quick-actions.js');
window.KTLayoutQuickCartPanel = require('./layout/extended/quick-cart.js');
window.KTLayoutQuickNotifications = require('./layout/extended/quick-notifications.js');
window.KTLayoutQuickPanel = require('./layout/extended/quick-panel.js');
window.KTLayoutQuickSearch = require('./layout/extended/quick-search.js');
window.KTLayoutQuickUser = require('./layout/extended/quick-user.js');
window.KTLayoutScrolltop = require('./layout/extended/scrolltop.js');
window.KTLayoutSearch = window.KTLayoutSearchOffcanvas = KTLayoutSearchInline = require('./layout/extended/search.js');

// Plugins
window.Popper = require('popper.js').default;
window.PerfectScrollbar = require('perfect-scrollbar/dist/perfect-scrollbar');

// KT Settings
window.KTAppSettings = {
  "breakpoints": {
    "sm": 576,
    "md": 768,
    "lg": 992,
    "xl": 1200,
    "xxl": 1200
  },
  "colors": {
    "theme": {
      "base": {
        "white": "#ffffff",
        "primary": "#0BB783",
        "secondary": "#E5EAEE",
        "success": "#1BC5BD",
        "info": "#8950FC",
        "warning": "#FFA800",
        "danger": "#F64E60",
        "light": "#F3F6F9",
        "dark": "#212121"
      },
      "light": {
        "white": "#ffffff",
        "primary": "#D7F9EF",
        "secondary": "#ECF0F3",
        "success": "#C9F7F5",
        "info": "#EEE5FF",
        "warning": "#FFF4DE",
        "danger": "#FFE2E5",
        "light": "#F3F6F9",
        "dark": "#D6D6E0"
      },
      "inverse": {
        "white": "#ffffff",
        "primary": "#ffffff",
        "secondary": "#212121",
        "success": "#ffffff",
        "info": "#ffffff",
        "warning": "#ffffff",
        "danger": "#ffffff",
        "light": "#464E5F",
        "dark": "#ffffff"
      }
    },
    "gray": {
      "gray-100": "#F3F6F9",
      "gray-200": "#ECF0F3",
      "gray-300": "#E5EAEE",
      "gray-400": "#D6D6E0",
      "gray-500": "#B5B5C3",
      "gray-600": "#80808F",
      "gray-700": "#464E5F",
      "gray-800": "#1B283F",
      "gray-900": "#212121"
    }
  },
  "font-family": "Roboto"
};
